import React from "react";

import {ReactComponent as LiveCasinoIcon} from "../images/icons/liveCasino.svg";
import {ReactComponent as Favorite} from "../images/icons/favorite.svg";

import img1 from "../images/cards/rocketLiveLounge/card-1.jpg";

const RocketLiveLoungeDB = [

      {
        image: img1,
        name: 'Live casino',
        icon: <Favorite/>
      },
      {
        image: img1,
        name: 'Live casino',
        icon: <Favorite/>
      },
      {
        image: img1,
        name: 'Live casino',
        icon: <Favorite/>
      },
      {
        image: img1,
        name: 'Live casino',
        icon: <Favorite/>
      },
  {
    image: img1,
    name: 'Live casino',
    icon: <Favorite/>
  },
  {
    image: img1,
    name: 'Live casino',
    icon: <Favorite/>
  },
  {
    image: img1,
    name: 'Live casino',
    icon: <Favorite/>
  },
  {
    image: img1,
    name: 'Live casino',
    icon: <Favorite/>
  },
]
export default RocketLiveLoungeDB